import "./assets/css/root.css";
import "./assets/css/global.css";
import "./assets/css/main.css";

import Vue from "vue";
import App from "./App.vue";
import Vuesax from "vuesax";
//import VueTheMask from 'vue-the-mask';

import "material-design-icons/iconfont/material-icons.css";

import "vuesax/dist/vuesax.css";
import moment from "moment";

import router from "./router";
import acl from "./acl/acl";
import Vuemask from "v-mask";

import NavBar from "./components/Dashboard/Nav.vue";
import SideBar from "./components/Dashboard/SideBar.vue";

import NewSale from "./components/Dashboard/NewSale.vue";

Vue.config.productionTip = false;

import VeeValidate, { Validator } from "vee-validate";
import attributesPTBR from "vee-validate/dist/locale/pt_BR";

const config = {
  events: "input|blur"
};

Vue.use(VeeValidate, config);
Validator.localize("pt_BR", attributesPTBR);

Vue.component("Navbar", NavBar);
Vue.component("SideBar", SideBar);
Vue.component("NewSale", NewSale);

Vue.use(Vuemask);

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: "#9B0E1C"
    }
  }
});

Vue.filter("Date_ddmmYYYY", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY hh:mm");
  }
});

export const bus = new Vue();

new Vue({
  router,
  acl,
  render: h => h(App)
}).$mount("#app");
